import { device } from "../../constants/mediaQueries";
import { isAppTypeIframe } from "../../getAppType";
import { useMediaQuery } from "./useMediaQuery";

export function useDevice() {
  const isMobile = !useMediaQuery(device.md);
  const isTabletOrMobile = !useMediaQuery(device.md);
  const isDesktop = useMediaQuery(device.md);
  const isLargeDesktop = useMediaQuery(device.xl);
  const isIframe = isAppTypeIframe();
  return { isMobile, isTabletOrMobile, isDesktop, isLargeDesktop, isIframe };
}
